import { Box, Flex, Heading, Text, SimpleGrid } from "@chakra-ui/react";
import Reveal from "../../components/motion";
import { BobContent } from "../../data/bobContent";

const BobAudience = ({ audience }: { audience: BobContent["audience"] }) => (
  <Box as="section" py={{ base: 16, md: 24 }} maxW="1200px" mx="auto" px={{ base: 5, md: 8 }}>
    <Reveal mb={12} maxW="640px">
      <Text color="bob.300" fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
        {audience.eyebrow}
      </Text>
      <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={4}>
        {audience.heading}
      </Heading>
      <Text color="slate.700">{audience.intro}</Text>
    </Reveal>

    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
      {audience.items.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.08}>
          <Flex
            direction="column"
            h="100%"
            border="1px solid"
            borderColor="chalk.400"
            borderRadius="xl"
            bg="chalk.50"
            p={6}
          >
            <Heading as="h3" fontFamily="heading" fontSize="lg" mb={3}>
              {item.title}
            </Heading>
            <Text fontSize="sm" color="slate.700">
              {item.description}
            </Text>
          </Flex>
        </Reveal>
      ))}
    </SimpleGrid>
  </Box>
);

export default BobAudience;
